<template>
  <b-card v-if="survey && questions" class="p-0 m-0" :header="survey.name">
    <div class="spnod-admin__account--section">
      <ul v-if="questions">
        <li class="spnod-admin__form--list pb-2" v-for="question in questions">
          <b-row class="mx-0">{{ question.question }}</b-row>
          <b-row class="mx-0"><span class="text-muted">{{ question.answer ? question.answer : 'N/A' }}</span></b-row>
        </li>
      </ul>
    </div>
    <b-button v-if="!forClient" class="spnod-admin__form--button" size="sm" @click="$emit('toggleSurvey')">Edit</b-button>
  </b-card>
</template>

<script>

export default {
  name: 'SurveyList',
  props: ['forClient', 'user'],
  data() {
    return {
      survey: {}
    }
  },
  computed: {
    questions: function() {
      if (this.survey && this.survey.questionsGroups) return this.survey.questionsGroups[0].questions
    }
  },
  mounted() {
    if (this.user && this.user.surveys) this.survey = this.user.surveys[0]
  },
  watch: {
    user: {
      handler() {
        if (this.user && this.user.surveys) this.survey = this.user.surveys[0]
      },
      deep: true
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/app/components/Surveys/SurveyList.vue?ac2ea5a0